import lightTheme from './lightTheme';
import darkTheme from './darkTheme';
import palette from './palette';
import typography from './typography';
import components from './components';

export { lightTheme, darkTheme, palette, typography, components };

export const getTheme = (mode = 'light') => {
  return mode === 'dark' ? darkTheme : lightTheme;
};

const themes = { light: lightTheme, dark: darkTheme };

export default themes;
